import { render, staticRenderFns } from "./NoFolders.vue?vue&type=template&id=1647a1c7"
import script from "./NoFolders.vue?vue&type=script&lang=js"
export * from "./NoFolders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports